import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || "";
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

// Single shared client. Persists the session so a login is remembered and shared
// (same project) across our apps. Falsy when not configured (keeps legacy auth working).
export const supabase = (SUPABASE_URL && SUPABASE_ANON_KEY)
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  : null;

// Cache the current access token so the axios interceptor can read it SYNCHRONOUSLY.
// Calling supabase.auth.getSession() inside the request interceptor contends with supabase-js v2's
// LockManager during mfa.verify() and can deadlock the post-login /auth/me call — so we never await
// the lock on the hot request path; we just mirror the token from auth-state events instead.
let _accessToken = null;
if (supabase) {
  supabase.auth.getSession().then(({ data }) => { _accessToken = data?.session?.access_token || null; });
  supabase.auth.onAuthStateChange((_event, session) => { _accessToken = session?.access_token || null; });
}

export function supabaseAccessToken() {
  return _accessToken;
}

// Prime the cache synchronously (e.g. with the aal2 token returned by mfa.verify) so the very next
// request uses it without waiting for the onAuthStateChange event to land.
export function setSupabaseAccessToken(token) {
  _accessToken = token || null;
}
